export default __webpack_public_path__ + "static/media/loginReverse.7b1af28b.svg";